import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { api, errMsg } from "../../lib/api";

const FIELDS = [
  ["company_name", "Company name *", "input"],
  ["address", "Registered office address", "textarea"],
  ["gstin", "GSTIN", "input"],
  ["phone", "Phone", "input"],
  ["email", "Email", "input"],
  ["deliver_to", "Default deliver-to address", "textarea"],
];

export const CompanyTab = () => {
  const [f, setF] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/settings").then((r) => setF(r.data));
  }, []);
  if (!f) return <p className="text-muted-foreground">Loading…</p>;

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.put("/settings", f);
      setF(data);
      toast.success("Company settings saved");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={save} className="panel space-y-4 p-4" data-testid="company-tab">
      {FIELDS.map(([k, label, type]) => {
        const props = { className: "field", value: f[k] || "", onChange: (e) => setF({ ...f, [k]: e.target.value }), "data-testid": `company-${k}-input` };
        return (
          <div key={k}>
            <label className="label">{label}</label>
            {type === "textarea" ? <textarea rows={3} {...props} /> : <input required={k === "company_name"} {...props} />}
          </div>
        );
      })}
      <div className="space-y-2">
        <span className="label">Terms and conditions</span>
        {f.terms.map((t, i) => (
          <div key={i} className="flex gap-2">
            <span className="mono pt-3 text-sm text-muted-foreground">{i + 1}.</span>
            <textarea rows={2} className="field" value={t} placeholder="(blank)"
              onChange={(e) => setF({ ...f, terms: f.terms.map((x, j) => (j === i ? e.target.value : x)) })} data-testid={`company-term-${i + 1}-input`} />
          </div>
        ))}
      </div>
      <button className="btn btn-primary w-full" disabled={busy} data-testid="company-save-btn">{busy && <Loader2 size={18} className="animate-spin" />} Save settings</button>
    </form>
  );
};
